export const getFilters = s => s.portfolio.get('filters')?.toJS();
export const getPortfolio = s => s.portfolio.get('portfolio').toJS();
export const getPortfolioLoading = s => s.portfolio.get('portfolioLoading');
